<template>
    <div class="bg-gray relative z-0">
        <div class="page-container">
            <div class="px-8 md:px-5 py-5 ">

                <h1 class="mb-10">
                    Welcome {{ first_name }}
                </h1>
                <div class="style-emph">
                    What can we help you with?
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                    <router-link
                            :to="{ name: 'bookServiceCall' }"
                            class="dashboard-nav-router ">

                        <i class="fas fa-wrench text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">
                            Book <br> Service Call
                        </div>
                    </router-link>

                    <router-link
                            :to="{ name: 'orderConsumables' }"
                            class="dashboard-nav-router">
                        <i class="fas fa-tint text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Order <br> Consumables</div>
                    </router-link>

                    <router-link
                            :to="{ name: 'meterReadings' }"
                            class="dashboard-nav-router">
                        <i class="fas fa-print text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Update Meter <br> Readings</div>
                    </router-link>

                    <router-link
                            v-if="profile.isManager()"
                            :to="{ name: 'managerUser' }"
                            class="dashboard-nav-router">
                        <i class="fas fa-users text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Manage <br> User Accounts</div>
                    </router-link>

                    <router-link
                            :to="{ name: 'profile' }"
                            class="dashboard-nav-router md:hidden">
                        <i class="fas fa-cog text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Profile</div>
                    </router-link>

                    <router-link
                            :to="{ name: 'contact' }"
                            class="dashboard-nav-router md:hidden">
                        <i class="fas fa-phone text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Contact <br> Sharp</div>
                    </router-link>

                    <router-link
                            :to="{ name: 'signOut' }"
                            class="dashboard-nav-router md:hidden">
                        <i class="fas fa-sign-out text-4xl text-blue"></i>
                        <div class="text-xl mt-6 text-blue leading-tight text-2xl">Log-out</div>
                    </router-link>

                </div>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';

    export default {
        name: 'Dashboard',

        data() {
            return {
                first_name: ''
            }
        },

        created: function () {
            this.first_name = this.profile.first_name;
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },
    }
</script>



